import { GET_APPOINTMENT_SUCCESS } from "../actions/patientAction"
  
const getAppointmentDataReducer = (state = [], { type,  data = [] }) => {
  switch (type) {
    case GET_APPOINTMENT_SUCCESS:
      return data
    default:
      return state
  }
}

export default getAppointmentDataReducer